import { formatPoints } from '@utils/commonUtils';

export function isValidPayload(payload) {
  return (Object.values(payload).indexOf(undefined) < 0);
}

export function formatFloatingPoints(num) {
  return formatPoints(parseInt(num, 10));
}

export default { isValidPayload, formatFloatingPoints };
